// Ironworks GC — Jobsite ledger (Graphite #1F2126 · Concrete #D9D4CC · Safety-orange #FF7A1A)
export const META = { brand: 'Ironworks GC', tag: 'General contractor · Bonded & insured · Lic. #GC-841 · Est. 2002', est: '2002' };
export const ROUTES = [
  { id: 'home', label: 'Yard', no: '00' },
  { id: 'jobs', label: 'Jobs ledger', no: '01' },
  { id: 'safety', label: 'Safety binder', no: '02' },
  { id: 'bid', label: 'Request bid', no: '03' },
];

export const JOBS = [
  { code: 'IW-2024-114', client: 'Halcyon Capital', t: 'TriBeCa office build-out · 22,000 sqft', dur: '14 mo', sqft: '22,000', val: '$8.4M', state: 'completed', img: 'https://images.pexels.com/photos/2469122/pexels-photo-2469122.jpeg?auto=compress&cs=tinysrgb&w=1400' },
  { code: 'IW-2025-118', client: 'Mr. & Mrs. Halford', t: 'Hudson Valley residence · ground-up', dur: '22 mo', sqft: '11,400', val: '$6.2M', state: 'in-progress', img: 'https://images.pexels.com/photos/259588/pexels-photo-259588.jpeg?auto=compress&cs=tinysrgb&w=1400' },
  { code: 'IW-2024-119', client: 'Avalon Hospitality', t: 'Casa di Bagni renovation · Lake Como', dur: '18 mo', sqft: '38,000', val: '$14.8M', state: 'completed', img: 'https://images.pexels.com/photos/1029599/pexels-photo-1029599.jpeg?auto=compress&cs=tinysrgb&w=1400' },
  { code: 'IW-2025-122', client: 'PS 412', t: 'Civic · Brooklyn elementary expansion', dur: '11 mo', sqft: '14,400', val: '$5.1M', state: 'in-progress', img: 'https://images.pexels.com/photos/2280551/pexels-photo-2280551.jpeg?auto=compress&cs=tinysrgb&w=1400' },
];

export const SAFETY = [
  { kpi: 'EMR', v: '0.62', n: 'Industry avg. 1.00 · 2024' },
  { kpi: 'Recordable injuries', v: '0', n: '24 months · 188,000 hrs' },
  { kpi: 'OSHA citations', v: '0', n: 'Trailing 5 years' },
  { kpi: 'Coverage', v: '$25M', n: 'GL + umbrella + workers comp' },
];

export const PHASES = [
  { code: '01', t: 'Pre-construction', d: 'Feasibility, estimating, permits, value-engineering, schedule build.' },
  { code: '02', t: 'Mobilization', d: 'Site logistics, fencing, utilities tie-in, bonding, safety stand-down.' },
  { code: '03', t: 'Sub buyout', d: 'Trade scopes drawn, bid lev to award. 32 trade partners on the rolodex.' },
  { code: '04', t: 'Construction', d: 'Daily logs, two-week look-ahead, weekly OAC, RFIs & submittals.' },
  { code: '05', t: 'Punch & closeout', d: 'TCO walk-down, punch ledger by floor, owner training, warranty book.' },
];
